import { SettingsObject } from '@hooks/useSettings';

export const defaults: Partial<SettingsObject> = {
    currency: 'USD',
    includeVAT: false,
    measurement: 'imperial',
    urlBaseName: 'favorites',
    isEnhancedMOV: true,
};
